
import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import './Auth.css';

const API_URL = process.env.REACT_APP_API_URL;

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { token } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const res = await fetch(`${API_URL}/api/users/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await res.json();

      if (!res.ok) {
        showNotification(
          data.error || 'Parola sıfırlama başarısız!',
          'error'
        );
        return;
      }

      showNotification(
        'Parola başarıyla sıfırlandı! Giriş yapabilirsiniz.',
        'success'
      );

      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      console.error('Parola sıfırlama hatası:', err);
      showNotification('Sunucuya bağlanılamadı.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page auth-reset-page">
      <section className="auth auth-reset-card">
        <span className="auth-kicker">Hesap güvenliği</span>

        <h1>Yeni parolanızı belirleyin</h1>

        <p className="auth-sub">
          Hesabınıza tekrar erişebilmek için yeni parolanızı aşağıya girin.
        </p>

        <form className="auth-form" onSubmit={handleResetPassword}>
          <label className="auth-field">
            <span className="auth-label">Yeni parola</span>

            <input
              type="password"
              className="auth-input"
              placeholder="Yeni parolanız"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              required
            />
          </label>

          <button
            className="auth-button"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Parola sıfırlanıyor...' : 'Parolayı sıfırla'}
          </button>
        </form>

        <p className="auth-footer">
          Parolanızı hatırladınız mı? <Link to="/login">Giriş yap</Link>
        </p>
      </section>
    </main>
  );
}

export default ResetPassword;
